export {default as Banner} from "./Banner";
export type {BannerProps} from "./Banner.props";
